module.exports = __webpack_public_path__ + "97b9237bec9ecd39bff33d36faabc7c5.pdf";